import React, { useState } from 'react';
import ReactDOM from 'react-dom'

import Header from '../shared/components/Header';
import { Link } from "react-router-dom";
import HttpCall from '../api/Http';
import InputField from "../shared/components/InputField";
import { useNavigate } from "react-router-dom";
import validator from 'validator'
import Alert from '../shared/Utils/AlertBox';
import Loader from '../shared/components/Loader';


export default function Login() {

    const [inputValue, setInputValue] = useState({ email: "", password: "" });
    const { email, password } = inputValue;
    const [terms, setTerms] = useState(false);
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValue((prev) => ({ ...prev, [name]: value, }));
    };


    function login(e) {

        e.preventDefault();
        if (!validator.isEmail(email)) {
            return Alert.show('Error', 'Please enter the valid email', 'error')
        }
        if (password.length < 5) {
            return Alert.show('Error', 'Please enter the valid password', 'error')
        }
        // if(!terms) {
        //     return Alert.show('Error','Please accept Privacy Policy and Terms & Conditions','error')
        // }
        let requestData = new FormData();
        requestData.append('email', email);
        requestData.append('password', password);
        setLoader(true);
        HttpCall.postRequest(`/User/api/auth/login/`, requestData).then(response => {
            setLoader(false);
            if (response.data.code == 200) {
                let user = response.data.data;
                if (user.length > 0) {
                    localStorage.setItem('user', JSON.stringify(user));
                    localStorage.setItem('isLoggedIn', '1');
                    navigate('/dashboard');
                }
            } else {
                localStorage.setItem('isLoggedIn', '0')
                setLoader(false);
                return Alert.show('Error', response.data.msg, 'error');
            }
        }).catch(err => {
            console.log(err);
            setLoader(false);
        })
    }

    return (
        <>
            <Header />
            {loader && <Loader />}
            <div className="basic-1 margin-top">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="text-container no-margin-top">
                                <h2>Login & Plan Your Business Growth Steps</h2>

                                <div className="form-container">
                                    <form id="requestForm" data-toggle="validator" data-focus="false">
                                        <InputField
                                            type="text"
                                            value={email}
                                            placeholder=""
                                            label="Email"
                                            name="email"
                                            onChange={handleChange}
                                        />
                                        <InputField
                                            type="password"
                                            value={password}
                                            placeholder=""
                                            label="Password"
                                            name="password"
                                            onChange={handleChange}
                                        />
                                        {/* <div className="form-group checkbox">
                                <input type="checkbox" id="rterms" checked={terms} onChange={(e) => { setTerms(!terms)}} name="terms" required />I agree with Getbound.ai stated <a href="privacy-policy.html">Privacy Policy</a> and <a href="terms-conditions.html">Terms & Conditions</a>
                                <div className="help-block with-errors"></div>
                            </div> */}
                                        <div className="form-group">
                                            <button type="submit" className="form-control-submit-button"
                                                onClick={login}>LOGIN</button>
                                        </div>
                                        <div className="form-message">
                                            <div id="rmsgSubmit" className="h3 text-center hidden"></div>
                                        </div>
                                    </form>
                                </div>
                                <div className="signupbtn">
                                    <div>
                                        <Link to="/signup" className="turquoise">Create an Account</Link>
                                    </div>
                                    <div>
                                        <Link to="/forget-password" className="turquoise">Forget Password</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="image-container">
                                <img className="img-fluid" src={process.env.PUBLIC_URL + 'assets/images/details-1-office-worker.svg'} alt="alternative" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="copyright">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <p class="p-small">Copyright © 2023 <a href="https://getbound.ai/">Getbound.ai</a> - All rights reserved</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}